import axios from 'axios';

const URL_BASE = '/servicios/gestion_servicios';

export default {
  activarSolicitudes(paramsSeleccion) {
    return axios.post(`${URL_BASE}/activar_solicitudes`, paramsSeleccion);
  },
  desactivarSolicitudes(paramsSeleccion) {
    return axios.post(`${URL_BASE}/desactivar_solicitudes`, paramsSeleccion);
  },
};
